module.exports = __webpack_public_path__ + "img/downloadWorkApp.54afb8b0.png";